import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Module, Question } from '@haleo-frontend/data-access/models';
import { EnvironmentUtils } from '@haleo-frontend/utils';

@Injectable({
    providedIn: 'root'
})
export class ModuleService {

    constructor(private http: HttpClient) {
    }

    getModule(programUuid: string, phaseUuid: string, moduleUuid: string): Observable<Module> {
        return this.http.get<Module>(EnvironmentUtils.env.api + `modules/${moduleUuid}?embed=contents,questions`);
    }

    setQuestionStatus(questionUuid: string, status: string, phase: any = null): Observable<Question> {

        const data = {
            op: 'replace',
            path: '/status',
            value: status,
            phase
        };
        return this.http.put<Question>(EnvironmentUtils.env.api + `questions/${questionUuid}`, data);
    }

    updateModule(moduleUuid: string, phase: string): Observable<Module> {

        const data = {
            op: 'replace',
            path: '/phase',
            phase: phase
        };

        return this.http.put<Module>(EnvironmentUtils.env.api + `modules/${moduleUuid}`, data);
    }
}
